// Canonical identifiers for the merge fields the editor surfaces as Unlayer "special links"
// rather than as merge-tag dropdown entries. Each one is referenced twice and the two must agree:
// UnlayerEditor registers it as a "special link" (href = the token), and useMergeFields hides the
// bare key from the merge-tag dropdown. Drift either shows the link twice or stops matching the
// backend guard. Kept import-free on purpose so components/composables can pull it without
// dragging in the merge-fields API/axios chain.
/**
 * "View in browser" (hosted web version) merge field (OP-6424). OPINK injects `web_version_url`
 * per-recipient at send time; the token `{{web_version_url}}` is substituted by Mailjet into the
 * delivered email.
 */
export const WEB_VERSION_MERGE_KEY = "web_version_url";
export const WEB_VERSION_MERGE_TOKEN = `{{${WEB_VERSION_MERGE_KEY}}}`;
/**
 * Manage-preferences link (US-5.19). OPINK injects it per recipient for Marketing sends only
 * (`UnsubscribeHeaderHelper.BuildManagePreferencesUrl`). Since OP-7732 it is the ONLY consent
 * link an email body carries, and the MISSING_PREFERENCES_LINK guard requires its literal token.
 */
export const PREFERENCE_CENTER_MERGE_KEY = "preference_center_url";
export const PREFERENCE_CENTER_MERGE_TOKEN = `{{${PREFERENCE_CENTER_MERGE_KEY}}}`;
